import axios from '../../utils/axios-wrapper';
import {
  THOMAS_AUTH_ENDPOINT_URL,
  AUTH0_CLIENT_ID,
  AUTH0_RESET_PASSWORD_URL,
  AUTH0_DB_CONNECTION,
} from '../../config';

const normalizeEmail = (input: string): string => {
  if (typeof input !== 'string') {
    return '';
  }
  return input.toLowerCase().trim();
};

export default {
  async sendResetPasswordEmail(email: string): Promise<{ message: string }> {
    const auth0Response = await axios({
      method: 'POST',
      url: AUTH0_RESET_PASSWORD_URL,
      withCredentials: false,
      headers: {
        'content-type': 'application/json',
      },
      data: {
        client_id: AUTH0_CLIENT_ID,
        email: normalizeEmail(email),
        connection: AUTH0_DB_CONNECTION,
      },
    })
      .then((response) => response)
      .catch((err) => {
        throw new Error(this.handleActionError(err));
      });
    return { message: auth0Response.data };
  },
  // This can be used for both the initial `forgotPassword` flow and for re-sending the confirmation code.
  // Calling this multiple times will result in multiple codes being sent.
  async forgotPassword(
    email: string
  ): Promise<{ data: any; statusCode: number; success: boolean }> {
    try {
      const response = await axios.post(
        `${THOMAS_AUTH_ENDPOINT_URL}/v2/forgotpassword`,
        {
          username: normalizeEmail(email),
        }
      );
      return {
        data: response.data,
        statusCode: response.status,
        success: true,
      };
    } catch (err: any) {
      if (err.response?.status === 400) {
        // if the error is 400 it means the user does not exist and because of that, we don't want to throw an error on Sentry
        return {
          data: null,
          statusCode: 400,
          success: false,
        };
      } else {
        throw new Error(this.handleForgotPasswordError(err as Error));
      }
    }
  },
  handleForgotPasswordError(err: Error) {
    console.error(err);
    return err.message;
  },
  handleActionError(err: Error) {
    console.error(err);
    return err.message;
  },
};
